import { createSoundWave } from "@/lib/audio";
import { useEffect, useRef } from "react";
import type WaveSurfer from "wavesurfer.js";
import { usePeaks } from "../hooks/use-peaks";

interface StaticWaveFormProps {
  isrc: string;
}

export function StaticWaveForm({ isrc }: StaticWaveFormProps) {
  const ref = useRef<WaveSurfer | null>(null);
  const peaks = usePeaks(isrc);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (ref.current != null) {
      return;
    }

    ref.current = createSoundWave(`#waveform-${isrc}`, {
      peaks: [peaks.peaks],
      duration: peaks.duration,
      interactive: false,
    });
  }, []);

  return <div id={`waveform-${isrc}`} className="relative z-0 aspect-[8/1] h-[40px]" />;
}
